import { fg } from '@atlaskit/platform-feature-flags';

import { UI_MODIFICATIONS_MODULE } from '../../../../../../../common/constants/constants';
import type { ExecutionContext } from '../../../../../../../common/types/execution-context';

import type { ExtensionData } from './types';

export const buildExtensionData = (executionContext: ExecutionContext): ExtensionData => {
	if (fg('uim_strip_analytics_view_type_from_extension_data')) {
		const { analyticsViewType: _analyticsViewType, ...executionContextWithoutAnalytics } =
			executionContext;

		return {
			type: UI_MODIFICATIONS_MODULE,
			...executionContextWithoutAnalytics,
		};
	}

	return {
		type: UI_MODIFICATIONS_MODULE,
		...executionContext,
	};
};
